import { useContext } from 'react';
import { AuthContext } from '../components';

export function useAuth() {
  return useContext(AuthContext);
}
